export const LABS = {
  key: 'LABS',
  value: 12,
  group: 3,
  title: 'health-record.labs.labs',
  menu_title: 'health-record.labs.title',
  icon: 'flask-outline',
  sub_title: 'Lab',
  editor: 'DiagnosticsEditor',
  message_translate: 'health-record.labs.message',
  imageURL: require('@assets/images/Health-Record-Icons/Icon-Labs.svg'),
  model_name: 'lab',
  resource: 'hr/lab/',
  plain_resource: 'lab',
  id: 'hr_id',
  headers: [
    {
      text: 'health-record.labs.lab-category',
      value: 'record.category',
    },
    {
      text: 'health-record.labs.lab-result',
      value: 'record.result_and_units',
    },
    {
      text: 'health-record.labs.diagnostic-date',
      value: 'record.date_formatted',
    },
    {
      text: 'health-record.labs.lab-normal-status',
      value: 'record.within_normal_value.value',
    },
    {
      text: 'health-record.actions',
      value: 'actions',
      sortable: false,
      width: '100px',
    },
  ],
  sortables: {
    record: {
      date_formatted: 'date',
      category: 'category',
      within_normal_value: {
        value: 'within_normal_value',
      },
      conclusion: 'conclusion',
      result: 'result',
      units: 'units',
    },
  },
  show_menu: true,
  background: 'linear-gradient(122.25deg, #0097A7 3.07%, #4DD0E1 100%)',
  color: '#2FABE0',
  opaque: '#D1EAF5',
}
